"use strict";

const tabs = document.querySelectorAll(".dm-key-features-tab");
const keyFeatures = document.querySelectorAll(".dm-key-feature-item");

const firstTab = document.querySelector(".dm-key-features-tab");
const firstKeyFeature = document.querySelector(".dm-key-feature-item");

const activateTab = function (tab) {
	tabs.forEach((el) => el.classList.remove("active-tab"));
	tab.classList.add("active-tab");
};

const activateKeyFeature = function (tab) {
	activateTab(tab);

	keyFeatures.forEach((el) => {
		el.classList.remove("active-tab");
	});

	keyFeatures.forEach((el) => {
		if (el.id === tab.id) {
			el.classList.add("active-tab");

			// Scroll to element with an offset of -100px
			const offset = -150;
			const bodyRect = document.body.getBoundingClientRect().top;
			const elementRect = el.getBoundingClientRect().top;
			const elementPosition = elementRect - bodyRect;
			const offsetPosition = elementPosition + offset;
			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth",
			});
		}
	});
};

const toggleKeyFeature = function () {
	firstTab.classList.add("active-tab");
	firstKeyFeature.classList.add("active-tab");

	tabs.forEach((tab) => {
		tab.addEventListener("click", () => {
			activateKeyFeature(tab);
		});
	});
};

toggleKeyFeature();


const initializeCarousel = () => {
	const carousel = jQuery(".dm-key-features-tabs").owlCarousel({
		loop: false,
		nav: false,
		dots: false,
		responsive: {
			0: {
				items: 1,
				margin: 0,
			},
			520: {
				items: 1,
				margin: 40,
			},
			769: {
				items: 3,
				margin: 70,
			},
		},
	});

	jQuery("#next.dm-key-features-tabs-control-single").click(function () {
		carousel.trigger("next.owl.carousel");
	});

	jQuery("#prev.dm-key-features-tabs-control-single").click(function () {
		carousel.trigger("prev.owl.carousel");
	});
};


const toggleKeyFeaturesOnScroll = function() {
    let previousClosestElement = null;

    document.addEventListener("scroll", () => {
        const header = document.querySelector(".dm-key-features-tabs-wrap"); // Adjust the selector as needed
        const elements = document.querySelectorAll(".dm-key-feature-item"); // Elements to check
    
        let closestElement = null;
        let closestDistance = Infinity;
    
        elements.forEach((element) => {
            const rect = element.getBoundingClientRect();
            const headerRect = header.getBoundingClientRect();
            const distance = Math.abs(rect.top - headerRect.bottom);
    
            if (distance < closestDistance) {
                closestDistance = distance;
                closestElement = element;
            }
        });
    
        if (closestElement && closestElement !== previousClosestElement) {

            previousClosestElement = closestElement;
    
            const newCurrentTab = document.querySelector(
                ".dm-key-features-tabs #" + closestElement.id,
            );
            activateTab(newCurrentTab);
    
            var targetSlide = jQuery(
                ".dm-key-features-tabs #" + closestElement.id,
            ).parent();
            var index = targetSlide.index();
            jQuery(".owl-carousel").trigger("to.owl.carousel", [index, 300]);
        }
    });    
}

document.addEventListener("DOMContentLoaded", function(event) {
    initializeCarousel();
    toggleKeyFeaturesOnScroll();
});
